/**
 * 디버깅 모드 여부 확인
 * @returns {boolean} 디버깅 모드인지 여부
 */
export const isDebug = () => {
  return process.env.REACT_APP_BUILD === "debug";
};

/**
 * 기본 URL
 * @param {boolean} release - 릴리즈 모드 URL 사용 여부
 * @returns {string} 기본 URL
 */
export const getBaseUrl = (release = false) => {
  if (isDebug()) {
    return release
      ? process.env.REACT_APP_RELEASE_BASE_URL
      : process.env.REACT_APP_DEBUG_BASE_URL;
  } else {
    return process.env.REACT_APP_BASE_URL;
  }
};

/**
 * 환경 설정 객체
 */
export const config = {
  isDebug: isDebug(),
  baseUrl: getBaseUrl(),
  debugBaseUrl: process.env.REACT_APP_DEBUG_BASE_URL,
  releaseBaseUrl: process.env.REACT_APP_RELEASE_BASE_URL,
  buildMode: process.env.REACT_APP_BUILD || "production",
};

export default config;

